import React, { useState } from 'react';

import Button from '@sats-group/ui-lib/react/button/button';
import HiddenInput from '@sats-group/ui-lib/react/hidden-input/hidden-input';
import Text from '@sats-group/ui-lib/react/text/text';

import { PtOffer as Props } from './pt-offer.props';

const PtOffer: React.FC<Props> = ({ banner, endpoint, hiddenInputs }) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = event => {
    if (isSubmitting || !(event.target as HTMLFormElement).checkValidity()) {
      event.preventDefault();
      return;
    }
    setIsSubmitting(true);
  };

  return (
    <form
      className="pt-offer"
      method="POST"
      action={endpoint}
      onSubmit={handleSubmit}
    >
      {hiddenInputs.map(input => (
        <HiddenInput key={input.name} {...input} />
      ))}
      <div className="pt-offer__image"></div>
      <div className="pt-offer__offer">
        <div className="pt-offer__descriptions">
          <div className="pt-offer__headlines">
            <Text theme={Text.themes.headline} size={Text.sizes.headline3}>
              {banner.title}
            </Text>
            <Text theme={Text.themes.headline} size={Text.sizes.headline3}>
              {banner.offer}
            </Text>
          </div>
          <Text size={Text.sizes.large}>{banner.description}</Text>
        </div>
        <div className="pt-offer__submit">
          <Button
            type="submit"
            text={banner.submit}
            disabled={isSubmitting ? true : undefined}
            spinning={isSubmitting}
            variant={Button.variants.ctaSecondaryWhite}
            size={Button.sizes.large}
          />
        </div>
      </div>
    </form>
  );
};

export default PtOffer;
